import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import { CampaignType, NewCampaignContext } from "contexts/NewCampaign";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { HEART_COLOR } from "styles/oneOffColor";

import { trackEvent } from "utils/tracking";

export default function SelectCampaignType() {
  const { selectedType, setSelectedType } = useContext(NewCampaignContext);
  const { currentOrg } = useContext(OrganizationUserContext);
  const navigate = useNavigate();

  if (currentOrg?.isBrand) {
    setSelectedType(CampaignType.savedList);
    return <Navigate to={"../collection"} replace />;
  }

  return (
    <>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h6" paragraph>
              Select Brands
            </Typography>
          </Grid>
          <Grid item container gap={1} xs={12}>
            <Button
              variant="outlined"
              disableElevation
              color="inherit"
              onClick={() => {
                setSelectedType(CampaignType.savedList);
              }}
              sx={[
                {
                  textTransform: "none",
                },
                selectedType === CampaignType.savedList && {
                  backgroundColor: "primary.light",
                  "&:hover": { backgroundColor: "primary.light" },
                },
              ]}
            >
              <Box
                component="span"
                className="fa-solid fa-bookmark"
                sx={{ mr: 1, color: HEART_COLOR }}
              />{" "}
              From Saved List
            </Button>
            <Button
              variant="outlined"
              color="inherit"
              disableElevation
              onClick={() => {
                setSelectedType(CampaignType.brandSearch);
              }}
              sx={[
                { textTransform: "none" },
                selectedType === CampaignType.brandSearch && {
                  backgroundColor: "primary.light",
                  "&:hover": { backgroundColor: "primary.light" },
                },
              ]}
            >
              <Box
                component="span"
                className="fa-solid fa-home"
                sx={{ mr: 1, color: "primary.main" }}
              />{" "}
              From Brand Search
            </Button>
            <Tooltip title="Pitch to brands that you contacted over 30 days ago that never replied">
              <Button
                variant="outlined"
                color="inherit"
                disableElevation
                onClick={() => {
                  setSelectedType(CampaignType.repitching);
                }}
                sx={[
                  { textTransform: "none" },
                  selectedType === CampaignType.repitching && {
                    backgroundColor: "primary.light",
                    "&:hover": { backgroundColor: "primary.light" },
                  },
                ]}
              >
                <Box
                  component="span"
                  className="fa-solid fa-arrows-rotate"
                  sx={{ mr: 1, color: "purple.dark" }}
                />{" "}
                Re-pitch Brands
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={!selectedType}
          variant="contained"
          disableElevation
          onClick={() => {
            trackEvent("New Campaign Dialog Selected Campaign Type", {
              "Campaign Type": selectedType,
            });
            if (selectedType === CampaignType.brandSearch) {
              navigate("../search");
            } else if (selectedType === CampaignType.savedList) {
              navigate("../collection");
            } else {
              navigate("../repitch");
            }
          }}
        >
          Next
        </Button>
      </DialogActions>
    </>
  );
}
